import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2fcb1cce&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2fcb1cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb1cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcb1cce')) {
      api.createRecord('2fcb1cce', component.options)
    } else {
      api.reload('2fcb1cce', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2fcb1cce&scoped=true&", function () {
      api.rerender('2fcb1cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/attendance_details/components/detail.vue"
export default component.exports